import {toJS} from "mobx";

export let build = function (
    requestParameters, resourceStorePropertiesToRequest, formInspector
) {
    const requestOptions = {};

    requestParameters.forEach((parameter) => {
        requestOptions[parameter.name] = parameter.value;
    });

    resourceStorePropertiesToRequest.forEach((propertyToRequest) => {
        const {name: parameterName, value: propertyName} = propertyToRequest;
        const propertyPath = typeof propertyName === 'string' ? propertyName : parameterName;
        if (propertyPath.includes(',')) {
            let pathes = propertyPath.split(',')
            let values = [];
            pathes.forEach(p => values.push(toJS(formInspector.getValueByPath('/' + p))));
            requestOptions[parameterName] = values.flat();
        } else {
            requestOptions[parameterName] = toJS(formInspector.getValueByPath('/' + propertyPath));
        }

    });

    return requestOptions;
}